import useResponsive from "@/components/hooks/useResponsive";
import useTitle from "@/components/hooks/useTitle";
import BodyContent from "@/components/landing-page/BodyContent";
import Footer from "@/components/landing-page/Footer";
import Header from "@/components/landing-page/Header";
import Main from "@/components/landing-page/Main";
import Section from "@/components/landing-page/Section";
import { routesURL } from "@/components/urls";
import Link from "next/link";
import React from "react";
import { IoCheckmarkSharp } from "react-icons/io5";
const Plan = ({ plan }) => {
  const { name, price, features } = plan;
  const isCustom = name === "Enterprise";

  return (
    <div className="relative flex min-h-[550px] flex-1 flex-col rounded-[8px] border border-[rgba(255,255,255,.12)] bg-[rgba(255,255,255,.02)]">
      <div className="border-b border-b-[rgba(255,255,255,.1)] px-[16px] py-[18px]">
        <div className=" font-inter font-medium text-[20px] text-[#ededed]">
          {name}
        </div>
        <div
          className=" font-firaCode font-medium text-[25px] text-[#b4b4b4]"
          dangerouslySetInnerHTML={{ __html: price }}
        ></div>
      </div>
      <ul className=" text-[12px] font-inter text-[#a9a9a9] px-[16px] py-[14px]">
        {features.map((feature, index) => (
          <li key={index} className=" my-[20px] flex items-center gap-x-3">
            <IoCheckmarkSharp size={12} />
            {feature}
          </li>
        ))}
      </ul>
      <div className="mt-auto px-[16px] pb-[20px] max-sm:flex max-sm:justify-center">
        <Link
          href={
            isCustom ? "https://cal.com/blockset/30min" : routesURL.dasboard
          }
          rel="noreferrer"
          target="__blank"
        >
          <button className="rounded-[7px] bg-[#323232] px-[10px] py-2 font-inter text-[13px] text-[#EDEDED] transition-[background-color,box-shadow,transform] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[#3d3d3d] hover:shadow-md active:translate-y-0 active:scale-[0.98]">
            {isCustom ? "Schedule a Demo" : "Start now"}
          </button>
        </Link>
      </div>
    </div>
  );
};
const Pricing = () => {
  const plans = [
    {
      name: "Free (30 Days)",
      price: "$0",
      features: [
        "100 MB cloud storage",
        " 30 MB/month of data querying",
        " 20 AI generations (Chat/Notebook)",
        "All File formats supported",
        "Notebook and Chat modes",
        "AI models (GPT4o-mini & Sonnet 3.5)",
      ],
    },
    {
      name: "Starter",
      price: "$9<span class=' text-[15px]'>/month</span> ",
      features: [
        "5 GB cloud storage",
        "100 MB/month of data querying",
        "200 AI generations (Chat/Notebook)",
        "All File formats supported",
        "Notebook and Chat modes",
        "More AI models (GPT4o, GPT4, Claude Opus)",
        "AWS S3 and GCP querying",
        "Postgres, MySQL connectors",
      ],
    },

    {
      name: "Growth",
      price: "$19<span class=' text-[15px]'>/month</span> ",
      features: [
        "20 GB cloud storage",
        "300 MB/month of data querying",
        "500 AI generations (Chat/Notebook)",
        "All File formats supported ",
        "Notebook and Chat modes",
        "More AI models (GPT4o, GPT4, Claude Opus)",
        "AWS S3 and GCP querying",
        "Postgres, MySQL connectors",
        "Faster query executions (better compute)",
      ],
    },

    {
      name: "Enterprise",
      price: "<span class=' text-[20px]'>Custom pricing</span>",
      features: [
        "Unlimited AI generations",
        "Different AI (LLM) model options",
        "AI fine-tuning on databases, SQL",
        "Self-Host deployment option",
        "Custom cloud storage quota",
        "Custom data querying quota",
        "Personalised onboarding and integration support",
        "Direct contact with Founder",
      ],
    },
  ];
  return (
    <React.Fragment>
      <h1 className=" font-geoGraph font-medium text-[#EDEDED] text-[35px] pt-[50px] text-center">
        Pricing
      </h1>
      <p className=" text-center text-[#a9a9a9] font-inter text-[15px] mt-6">
        FREE plan lets you use Blockset and build a sense of how powerful it
        is. <br />
        Upgrade to higher plans for more storage, faster executions and more AI
        usage and overall <br /> increased usage limits.
      </p>
      <div className=" flex gap-5 max-sm:flex-col pb-[200px] pt-[80px] max-sm:pb-[80px]">
        {plans.map((plan, index) => (
          <Plan plan={plan} key={index} />
        ))}
      </div>
    </React.Fragment>
  );
};

const pricing = () => {
  useTitle("Pricing ");

  return (
    <>
      <div className=" overflow-x-hidden">
        <Main>
          <Header showHero={false}>
            <BodyContent>
              <Section>
                <Pricing />
              </Section>
            </BodyContent>
          </Header>
          <Footer />
        </Main>
      </div>
    </>
  );
};

export default pricing;
